import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import { Box, TableCell } from '@mui/material';
import { styled } from '@mui/material/styles';

import { SortOrder } from '../types';

const SortIcon = styled('span')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginLeft: theme.spacing(1),
  color: 'white',
}));

interface SortableTableHeaderProps {
  label: string;
  sortColumn: string;
  currentSortColumn: string;
  sortOrder: SortOrder;
  onSort: () => void;
  stickyCellStyle: React.CSSProperties;
}

export const SortableTableHeader = ({
  label,
  sortColumn,
  currentSortColumn,
  sortOrder,
  onSort,
  stickyCellStyle,
}: SortableTableHeaderProps) => {
  const isActive = sortColumn === currentSortColumn;

  return (
    <TableCell sx={{ ...stickyCellStyle, cursor: 'pointer' }} onClick={onSort}>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        {label}
        {isActive && (
          <SortIcon>
            {sortOrder === 'ASC' ? <ArrowUpwardIcon fontSize="small" /> : <ArrowDownwardIcon fontSize="small" />}
          </SortIcon>
        )}
      </Box>
    </TableCell>
  );
};

